import React from "react";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Container, Col, Row, Breadcrumb, Card } from "react-bootstrap";
import banner from "../assets/images/banner-vadraj-cement.jpg";
import bannermobile from "../assets/images/banner-vadraj-cement-m.jpg";
import suratPlant from "../assets/images/Surat-Cement-Plant.png";
import kutchPlant from "../assets/images/Kutch-Cement-Plant.png";
import img1 from "../assets/images/infra1.png";
import img2 from "../assets/images/infra2.png";
import img3 from "../assets/images/inn2.png";
import img4 from "../assets/images/inn1.png";
import img5 from "../assets/images/inn3.png";
import img6 from "../assets/images/inn4.png";
import img7 from "../assets/images/inn5.png";
import img8 from "../assets/images/inn6.png";
import img9 from "../assets/images/nabl.jpg";
import pdfIcon from "../assets/images/pdf_icon.png";
import healthpolicy from "../assets/images/Health_and_Safety_Policy.pdf";
import mbm01 from "../assets/images/ingallery01.jpg";
import mbm02 from "../assets/images/ingallery02.jpg";
import mbm03 from "../assets/images/ingallery03.jpg";
import mbm04 from "../assets/images/ingallery04.jpg";
import mbm05 from "../assets/images/ingallery05.jpg";
import mbm06 from "../assets/images/ingallery06.jpg";
import mbm07 from "../assets/images/ingallery07.jpg";
import mbm08 from "../assets/images/ingallery08.jpg";

import f1 from "../assets/images/floors-00.jpg";
import f2 from "../assets/images/floors-01.jpg";
import f3 from "../assets/images/floors-02.jpg";
import f4 from "../assets/images/floors-03.jpg";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import SeoHead from "../common/SeoHead";

const settings = {
  autoplay: true,
  autoplaySpeed: 2000,
  dots: false,
  arrow: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  mode: "center",
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      },
    },
  ],
};
const floorSlide = {
  dots: true,
  arrow: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  mode: "center",
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      },
    },
  ],
};
const VadrajCement = () => {
  const { t } = useTranslation();
  return (
    <div className="inncentre-page">
      <Helmet>
        <title>{t("SEO.vadrajCement.title")}</title>
        <meta name="keywords" description="" />
        <meta name="description" content={t("SEO.vadrajCement.desc")} />
        <link rel="canonical" href="" />
      </Helmet>

      <div className="banner text-center position-relative">
        <img className="desktopbannerinner w-100" src={banner} alt="" />
        <img className="mobilebannerinner w-100" src={bannermobile} alt="" />

        <div className="breadouter">
          <div className="container">
            <Breadcrumb className="mb-0 py-2">
              <Breadcrumb.Item href="#">{t("breadcrumb.home")}</Breadcrumb.Item>
              <Breadcrumb.Item href="#">{t("about.title")}</Breadcrumb.Item>
              <Breadcrumb.Item
                active
                href="https://getbootstrap.com/docs/4.0/components/breadcrumb/"
              >
                {t("navigation.vadrajCement")}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>
      <Container className="py-5">
        <section className="tptextbx py-0">
          <h2 className="grad-heading">{t("vadrajCement.aboutTitle")}</h2>
          <p>{t("vadrajCement.aboutDesc")}</p>
          <p>{t("vadrajCement.aboutDesc2")}</p>
          <p>{t("vadrajCement.aboutDesc3")}</p>
        </section>

        <section className="tptextbx py-0">
          <h2 className="grad-heading">
            {t("vadrajCement.Becomingpart.title")}
          </h2>
          <p>{t("vadrajCement.Becomingpart.desc1")}</p>
        </section>
        <section className="tptextbx py-0">
          <h2 className="grad-heading">
            {t("vadrajCement.Strengthening.title")}
          </h2>
          <p>{t("vadrajCement.Strengthening.desc1")}</p>
          <p>{t("vadrajCement.Strengthening.desc2")}</p>
        </section>
        <section className="tptextbx py-0">
          <h2 className="grad-heading">
            {t("vadrajCement.Drivingsynergies.title")}
          </h2>
          <p>{t("vadrajCement.Drivingsynergies.desc1")}</p>
        </section>
        <section className="process pb-0 pt-5">
          <h2 className="grad-heading">
            {t("vadrajCement.ManufacturingFacilities.title")}
          </h2>
          <Row className="">
            <Col md={6} className="">
              <article className="mx-auto w-100">
                <h3
                  className="mb-3 w-100"
                  style={{
                    fontSize: "24px",
                    textAlign: "left",
                    color: "#42bb52",
                    fontWeight: "bold",
                  }}
                >
                  {t("vadrajCement.ManufacturingFacilities.suratPlant")}
                </h3>
                <div className="icnbx w-100 h-auto">
                  <a
                    target="_blank"
                    href={t(
                      "vadrajCement.ManufacturingFacilities.suratmapLink"
                    )}
                  >
                    <img
                      src={suratPlant}
                      alt=""
                      className="img-fluid"
                      style={{ borderRadius: "20px" }}
                    />
                  </a>
                </div>
              </article>
            </Col>
            <Col md={6} className="">
              <article className="mx-auto w-100">
                <h3
                  className="mb-3 w-100"
                  style={{
                    fontSize: "24px",
                    textAlign: "left",
                    color: "#42bb52",
                    fontWeight: "bold",
                  }}
                >
                  {t("vadrajCement.ManufacturingFacilities.kutchPlant")}
                </h3>
                <div className="icnbx w-100 h-auto">
                  <a
                    target="_blank"
                    href={t(
                      "vadrajCement.ManufacturingFacilities.kutchmapLink"
                    )}
                  >
                    <img
                      src={kutchPlant}
                      alt=""
                      className="img-fluid"
                      style={{ borderRadius: "20px" }}
                    />
                  </a>
                </div>
              </article>
            </Col>
          </Row>
        </section>
        <section>
          <Row className="py-5">
            <Col md={12} className="mb-4">
              <p
                dangerouslySetInnerHTML={{
                  __html: t("vadrajCement.mainVadraj.vadrajink"),
                }}
              ></p>
            </Col>
          </Row>
        </section>
      </Container>
    </div>
  );
};

export default VadrajCement;
